import { render, staticRenderFns } from "./WorkRow.vue?vue&type=template&id=47d2eb3a"
import script from "./WorkRow.vue?vue&type=script&lang=js"
export * from "./WorkRow.vue?vue&type=script&lang=js"
import style0 from "./WorkRow.vue?vue&type=style&index=0&id=47d2eb3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports